namespace app.upgraded {
    "use strict";

    export class UpgradedCommunicationService {

        
        private ui2AlreadyLoaded: boolean = false;

        private currentStateChangeRequest = {
            request: null
        };

        /** @ngInject **/
        constructor(private $window: ng.IWindowService, private $rootScope: ng.IRootScopeService, private $state: ng.ui.IStateService,
                private msNavigationService, private $stateParams: ng.ui.IStateParamsService, private $http: ng.IHttpService,
                private properties: app.support.constants.Properties, private $q: ng.IQService, private stylesLoadingService,
                private $ocLazyLoad, private $mdDialog, private $translate, private $injector: ng.auto.IInjectorService) {
            $window.addEventListener("message", (event) => this.handleMessage(event), false);
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => {
                if (toState.name === "app.upgraded") {
                    if ($state.$current["name"] !== "app.upgraded") {
                        if (!this.hasUi2AlreadyLoaded()) {
                            this.$rootScope.$broadcast("upgraded:frame-url-changed", toParams.url);
                        }
                    }
                    this.currentStateChangeRequest.request = {
                        url: toParams.url
                    };
                    this.updateUrl(toParams.url);
                } else {
                    if ($state.$current["name"] === "app.upgraded") {
                        this.currentStateChangeRequest.request = {
                            url: "/empty"
                        };
                    }
                }
            });
            $rootScope.$on("user:exited", () => {
                this.ui2AlreadyLoaded = false;
            });
        }

        private handleMessage(message) {
            if (message.data.type === "upgraded") {
                if (message.data.operation === "startedLoadingRoute") {
                    this.$rootScope["loadingProgress"] = true;
                    this.$rootScope.$apply();
                } else if (message.data.operation === "finishedLoadingRoute") {
                    this.$rootScope["loadingProgress"] = false;
                    this.$rootScope.$apply();
                    if (message.data.url) {
                        this.updateUrl(message.data.url.slice(1).replace(/\?ts=\d+$/g, "")); // Remove um possível ?ts=123... apendado na URL
                    }
                } else if (message.data.operation === "changeStfDigitalState") {
                    this.$state.go(message.data.state);
                } else if (message.data.operation === "eventBroadcast") {
                    this.$rootScope.$broadcast(message.data.event.name, message.data.event.payload);
                }
            }
        }
        
        private updateUrl(url): void {
            if (url === "tarefas") {
                // TODO Redirecionar para tarefas da UI1.
            } else {
                this.$state.transitionTo("app.upgraded", {
                    url: url
                }, {
                    location: true,
                    inherit: false,
                    relative: this.$state.$current,
                    notify: false
                });
                this.$stateParams["url"] = url;
                this.$rootScope.$broadcast("upgradedRouteChanged");
            }
        }

        public getCurrentStateChangeRequest() {
            return this.currentStateChangeRequest;
        }

        public setUi2AlreadyLoaded(value: boolean): void {
            this.ui2AlreadyLoaded = value;
        }

        public hasUi2AlreadyLoaded(): boolean {
            return this.ui2AlreadyLoaded;
        }

    }

    angular
        .module('app.upgraded')
        .service('app.upgraded.UpgradedCommunicationService', UpgradedCommunicationService);
}
